export default {
    routerName: '角色新增',
    role: {
        name: '角色名',
        code: '代号',
        authority: '权限',
        status: '状态',
        open: '启用',
        close: '停用',
        sortOrder: '排序',
        remark: '备注',
    },
    menu: {
        menuDistribute: '分配',
    },
};
